/**
 * Lets the user download the completed analysis as JSON or plain text.
 * PDF export is left as an easy extension point (e.g. via jsPDF) — noted
 * inline below.
 */
import React from 'react';

function downloadBlob(content, fileName, mimeType) {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function buildTextReport(result) {
  const { finalAnalysis = {}, transcript = {}, originalName } = result;
  const lines = [];
  lines.push(`VIDEO ANALYSIS REPORT`);
  lines.push(`File: ${originalName}`);
  lines.push(`Generated: ${result.generatedAt}`);
  lines.push('');
  lines.push('EXECUTIVE SUMMARY');
  lines.push(finalAnalysis.executive_summary || 'N/A');
  lines.push('');
  lines.push('TIMELINE');
  (finalAnalysis.timeline || []).forEach((t) => lines.push(`${t.timestamp}  ${t.event}`));
  lines.push('');
  lines.push('OVERALL STORY');
  lines.push(finalAnalysis.overall_story || 'N/A');
  lines.push('');
  lines.push('TRANSCRIPT');
  (transcript.segments || []).forEach((s) => lines.push(`${s.timestamp}  ${s.text}`));
  return lines.join('\n');
}

export default function DownloadButtons({ result }) {
  if (!result) return null;

  return (
    <div className="flex gap-2">
      <button
        onClick={() => downloadBlob(JSON.stringify(result, null, 2), `${result.jobId}.json`, 'application/json')}
        className="text-sm font-medium px-3.5 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-colors"
      >
        Download JSON
      </button>
      <button
        onClick={() => downloadBlob(buildTextReport(result), `${result.jobId}.txt`, 'text/plain')}
        className="text-sm font-medium px-3.5 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-colors"
      >
        Download Report
      </button>
      {/* PDF export: integrate jsPDF or call a backend /api/report/:jobId/pdf endpoint here. */}
    </div>
  );
}
